import { Component, OnInit } from '@angular/core';
import { BusyIndicatorService } from './busy-indicator.service';

@Component({
  standalone: false,
  selector: 'app-busy-indicator',
  templateUrl: './busy-indicator.component.html',
  styleUrls: ['./busy-indicator.component.scss']
})
export class BusyIndicatorComponent implements OnInit {

  constructor(public busyService: BusyIndicatorService) {

  }

  ngOnInit() {
  }

}
